import React from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';

import {LOOK_OVERLAYS} from "../../core/constants";
import {setLookOverlayOpened} from "../../../../actions/lookFunctions";
import Analytics, {PRODUCT_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {isIframe} from "../../../../misc/helpers";

const GroheExitButton = (props) => {

  const {intl, setLookOverlayOpened, fabricatorData} = props;

  const isLixil = isIframe() && fabricatorData.isLixil;
  if (!isLixil && !fabricatorData.websiteUrl) {
    return null
  }

  const exitButtonClick = () => {
    Analytics.sendClickEvent(PRODUCT_JOURNEY_ANALYTIC_EVENTS.productTopButtonsExit);
    setLookOverlayOpened(LOOK_OVERLAYS.exit);
  }

  return (
    <div className={"gm-buttons__button"}>
      <IconButton aria-label={intl.formatMessage({id: "iconButton.exit"})}
                  className="look-icon look-icon--small1 look-icon--grohe"
                  onClick={exitButtonClick}>
        <CloseIcon/>
      </IconButton>
    </div>
  )
};

const mapStateToProps = (store) => {
  const fabricatorData = store.fabricatorState;

  return {
    fabricatorData
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(GroheExitButton)
)
